<template>
  <div class="vt-video-container">
    <div v-if="marketing" class="vt-video-container__content">
      <video-youku
        v-if="video && video.youku"
        :video-url="video.youku"
        :poster="poster"
        :autoplay="autoplay"
        :auto-size="autoSize">
      </video-youku>

      <video-youtube
        v-if="video && video.youtube"
        :video-url="video.youtube"
        :poster="poster"
        :autoplay="autoplay"
        :auto-size="autoSize">
      </video-youtube>

      <video-local
        v-if="video && video.local"
        :video-url="video.local"
        :poster="poster"
        :autoplay="autoplay"
        :auto-size="autoSize">
      </video-local>
    </div>
    <div v-else class="vt-video-container__content">
      <onetrust-blocker></onetrust-blocker>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'

  import VideoYouku from './vt-video-youku.vue'
  import VideoYoutube from './vt-video-youtube.vue'
  import VideoLocal from './vt-video-local.vue'

  export default {
    name: 'vt-video',
    props: {
      videos: {
        type: Object,
        default: null
      },
      poster: {
        type: String,
        default: '/assets/niobiumtech/images/no-image.png'
      },
      preferr: {
        type: String,
        default: 'youtube'
      },
      autoplay: {
        type: Boolean,
        default: false
      },
      lazyload: {
        type: Boolean,
        default: false
      },
      autoSize: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      marketing() {
        this.getVideo()
      }
    },
    data() {
      return {
        video: null,
        blocked: true
      }
    },
    mounted() {
      this.getVideo()
    },
    computed: {
      ...mapGetters('onetrust', [
        'marketing',
        'date'
      ])
    },
    methods: {
      getVideo() {
        this.video = _.pick(this.videos, [this.preferr])
      }
    },
    components: {
      VideoYouku,
      VideoYoutube,
      VideoLocal
    }
  }
</script>

<style lang="scss" scoped>
  .vt-video-container {
    width: 100%;
    height: 100%;
    max-height: 100vh;

    &__content {
      width: 100%;
      height: 100%;
    }
  }
</style>
